import type { IStore } from '@repo/common';
import type { IStorageController } from '@repo/common/types/IStorageController';

export abstract class StorageController implements IStorageController {
  /**
   * Default implementation that routes to appropriate storage type
   */
  async loadDurableStore(filename: string): Promise<IStore> {
    // Check if we're trying to load a keychain store
    if (filename.endsWith('.keychain')) {
      return this.loadAuthStore(filename);
    }

    // For non-keychain stores, use plain store
    return this.loadPlainStore(filename);
  }

  /**
   * Abstract method that must be implemented by platform-specific controllers
   */
  abstract loadAuthStore(service: string): Promise<IStore>;

  /**
   * Abstract method that must be implemented by platform-specific controllers
   */
  abstract loadPlainStore(filename: string): Promise<IStore>;

  /**
   * Default implementation for isGlobal - can be overridden by platform-specific controllers
   */
  isGlobal(filename: string): boolean {
    return filename.includes('.keychain') || filename === '.settings.dat';
  }

  /**
   * Default implementation for getStorageType - can be overridden by platform-specific controllers
   */
  getStorageType(filename: string): 'keychain' | 'plain' {
    return filename.includes('.keychain') ? 'keychain' : 'plain';
  }
}
